// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextImage$PorterinFeature from "./NextImage.mjs";
import * as CustomerReviewCardModuleScss from "../styles/common/CustomerReviewCard.module.scss";

var styles = CustomerReviewCardModuleScss;

function CustomerReviewCard(Props) {
  var testimonial = Props.testimonial;
  var star_icon = Props.star_icon;
  return React.createElement("div", {
              className: styles.container
            }, React.createElement("div", {
                  className: styles["customer-details"]
                }, React.createElement("div", {
                      className: styles.image
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: testimonial.profile_pic.path,
                          height: 40.0,
                          width: 40.0,
                          quality: 75.0,
                          alt: testimonial.profile_pic.alt_text
                        })), React.createElement("div", {
                      className: styles["customer-details-title"]
                    }, React.createElement("div", {
                          className: styles.name
                        }, testimonial.customer_name), React.createElement("div", {
                          className: styles["porter_service-and-rating"]
                        }, React.createElement("div", {
                              className: styles.porter_service
                            }, testimonial.porter_service + ","), React.createElement("div", {
                              className: styles.rating
                            }, testimonial.rating.toFixed(1), React.createElement("div", {
                                  className: styles.star
                                }, React.createElement(NextImage$PorterinFeature.make, {
                                      src: star_icon.path,
                                      height: 12.0,
                                      width: 12.0,
                                      quality: 75.0,
                                      alt: star_icon.alt_text
                                    })))), React.createElement("div", {
                          className: styles.place
                        }, testimonial.city))), React.createElement("div", {
                  className: styles.review
                }, testimonial.testimonial_text));
}

var Link;

var make = CustomerReviewCard;

export {
  styles ,
  Link ,
  make ,
}
/* styles Not a pure module */
